<script>
import api from '@/helpers/api'
export default {
  name: 'shop-form-dialog.app',
  props: {
    visible: { type: Boolean, default: false },
    shopId: { type: String }
  },
  data: () => ({
    shop: { is_active: true },
    isLoading: false
  }),
  methods: {
    reset () {
      this.shop = {
        is_active: true
      }
    },
    onCancel () {
      this.$emit('update:visible', false)

      this.$nextTick(() => {
        this.reset()
      })
    },
    async init () {
      if (this.isUpdate) {
        let item = await api.shops.fetch({
          id: this.shopId
        })

        this.shop = { ...item }
      } else this.reset()
    },
    async onSave () {
      let valid = true

      if (valid) {
        try {
          let item
          this.isLoading = true
          if (this.isUpdate) {
            item = await api.shops.update({
              ...this.shop,
              id: this.shopId
            })
          } else {
            item = await api.shops.create({
              ...this.shop
            })
          }
          this.$bvToast.toast(`Shop '${this.shop.name}' was added!`, {
            title: 'Shop Added',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false

          this.$emit('created', item)
          this.onCancel()
        } catch (err) {
          this.$bvToast.toast(`${err}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        }
      }
    }
  },
  watch: {
    shopId: { handler: 'init', immediate: true },
    visible: {
      handler (v) {
        if (v) this.init()
      }
    }
  },
  computed: {
    isUpdate () {
      return !!this.shopId
    },
    title () {
      return this.isUpdate ? 'Edit Shop' : 'New Shop'
    },
    saveBtnLabel () {
      return this.isUpdate ? 'Save Changes' : 'Create Shop'
    }
  }
}
</script>
<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="sm"
  >
    <b-form-group label="Name" label-for="shop_name" label-cols-sm="3">
      <b-form-input
        id="shop_name"
        v-model="shop.name"
        type="text"
        required
        autocomplete="shop_name"
        placeholder="Short name"
        :style="{ maxWidth: '350px' }"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label-for="is_active"
      label-cols-sm="3"
      class="d-flex align-items-center"
    >
      <template v-slot:label>
        <div class="d-flex align-items-center pointer">
          Active
        </div>
      </template>
      <b-form-checkbox
        switch
        size="lg"
        id="is_active"
        v-model="shop.is_active"
        name="is_active"
        inline
      ></b-form-checkbox>
    </b-form-group>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end" style="width: 100%">
        <div>
          <b-button variant="link" @click="onCancel" class="mr-2"
            >Cancel</b-button
          >
          <b-btn variant="primary" class="btn-label" @click="onSave">
            <i class="bx bxs-save label-icon"></i>
            {{ saveBtnLabel }}
          </b-btn>
        </div>
      </div>
    </template>
  </b-modal>
</template>
